import { AxiosResponse } from "axios";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/fitness_statistics/upload_file"

export class UploadEcrFileCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    newFormData: FormData = new FormData();

    constructor(file: any) {
        super();
        this.newFormData = new FormData();
        this.newFormData.append("file", file, file.name);
    }

    public async execute(): Promise<AxiosResponse> {
        var res = await this.executeCommand(this.newFormData, { "Content-Type": "multipart/form-data" });
        return res;
    }

}
